import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { apiGet, apiPut } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import UpdateDialogBox from "./User/UpdateDialogBox";

const BlockMarket = () => {
  const [sportData, setSportData] = useState({});
  const [blockStatus, setBlockStatus] = useState(false);
  const [sportId, setSportId] = useState("");
  const [sportStatus, setSportStatus] = useState("");
  const [isLoader, setLoader] = useState(false);

  const getSportData = async () => {
    const { status, data: response_users } = await apiGet(apiPath.sportList);
    if (status === 200 && response_users.success) {
      setSportData(response_users.results);
    }
  };

  useEffect(() => {
    getSportData();
  }, []);

  const openConfirm = (id, status) => {
    setSportId(id);
    setSportStatus(status);
    setBlockStatus(true);
  };

  const closeConfirm = () => {
    setBlockStatus(false);
    setSportId("");
    setSportStatus("");
  };

  const confirmToggle = async () => {
    if (!sportId) return;
    setLoader(true);
    try {
      const { status, data: response_users } = await apiPut(apiPath.updateSportsListingStatus + `/${sportId}`, {
        status: sportStatus === "active" ? "inActive" : "active",
      });
      if (status === 200 && response_users.success) {
        toast.success(response_users.message);
        closeConfirm();
        getSportData();
      } else {
        toast.error(response_users.message);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      toast.error(err?.response?.data?.message);
    }
    setLoader(false)
  };

  const rows = sportData?.data || [];

  return (
    <app-block-market>
      <div className="main_wrap">
        <div className="full-wrap">
          <h2>Sport Listing </h2>

          <table id="table_log" style={{ marginTop: "13px" }} className="table01 funwrap">
            <thead>
              <tr>
                <th width="15%" className="align-L">
                  S.No.
                </th>
                <th width="18%">Name</th>
                <th width="18%"> Status</th>
                <th width="16%">Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows.map((item, index) => (
                  <tr key={item?._id || index}>
                    <td className="align-L">{index + 1}</td>
                    <td>
                      <span className="red">
                        <a href="#"> {item?.name} </a>
                      </span>
                    </td>
                    <td>
                      {item?.name} {item?.status === "active" ? " is ON" : " is OFF"}
                    </td>
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={item?.status === "active"}
                          disabled={!!item?.isUplineDisable}
                          onClick={(e) => {
                            openConfirm(item?._id, item?.status);
                          }}
                          readOnly
                        />
                        <span className="slider round slider-block-market" />
                      </label>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>No records found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {blockStatus && (
        <UpdateDialogBox
          open={blockStatus}
          onClose={closeConfirm}
          onSubmit={confirmToggle}
          isLoader={isLoader}
          headerTitle={"Block/Un-Block Sport"}
          title={`You Want to Make This Sport ${sportStatus === "active" ? "InActive" : "Active"}?`}
        />
      )}
    </app-block-market>
  );
};

export default BlockMarket;
